export const PENDING_COMMAND_EXISTS_MESSAGE = 'Pending command exists';

export const STUDY_PENDING_COMMAND = {
  STOP_STUDY: 'StopStudy',
  UPDATE_STUDY: 'UpdateStudy',
};
